import moment from "moment";
import { ColumnConfig, numberSort, SortDirections, wafflesKeyColumnName } from "@app/shared/waffles";
import { ProviderSetVersionModel } from "@app/provider-sets/providerSet";
import { ProviderSetVersionSummaryType } from "@app/provider-sets/enumerations";
import { JSX } from "react";

export interface ProviderSetSummaryCountTableData {
  [wafflesKeyColumnName]: string;
  change: JSX.Element;
  changeNumeric?: number;
  changePerc: JSX.Element;
  changePercNumeric?: number;
  compareVersionCount: JSX.Element;
  compareVersionCountNumeric?: number;
  count: JSX.Element;
  countNumeric?: number;
  description: string;
  descriptionNumeric?: number;
  versionCount: JSX.Element;
  versionCountNumeric?: number;
}

export interface ProviderSetSummaryDetailProps {
  providerSetId: string;
  version: ProviderSetVersionModel;
  compareVersion: ProviderSetVersionModel;
  activeAccordion: ProviderSetVersionSummaryType,
  onUpdate: (activeAccordion: ProviderSetVersionSummaryType) => void;
}


export const customSort = (records: ProviderSetSummaryCountTableData[], column: keyof ProviderSetSummaryCountTableData, sortDirection: SortDirections): ProviderSetSummaryCountTableData[] => {

  const multiplier = sortDirection === SortDirections.Asc ? 1 : -1;

  switch (column) {
    case "description":
      if (records[0]?.descriptionNumeric)
        return numberSort(records, "descriptionNumeric", multiplier)
      return records.sort((a, b) => (a[column] > b[column] ? 1 : -1) * multiplier);
    case "count":
      return numberSort(records, "countNumeric", multiplier);
    case "change":
      return numberSort(records, "changeNumeric", multiplier);
    case "changePerc":
      return numberSort(records, "changePercNumeric", multiplier);
    case "compareVersionCount":
      return numberSort(records, "compareVersionCountNumeric", multiplier);
    case "versionCount":
      return numberSort(records, "versionCountNumeric", multiplier);
    default:
      return records;
  }
};

export const createConfig = (description: string, props: ProviderSetSummaryDetailProps, countDesc?: string): ColumnConfig => {

  if (!countDesc)
    countDesc = "Count";

  const columnConfig: ColumnConfig = {
    change: {
      displayText: "Change",
      hidden: false,
      testId: "change",
    },
    changePerc: {
      displayText: "% Change",
      hidden: false,
      testId: "changePerc",
    },
    compareVersionCount: {
      displayText: (!!props.compareVersion ? `${countDesc} ${moment.utc(props.compareVersion.dateCreated).local().format("MMM DD, YYYY h:mm:ss A")}` : ""),
      hidden: false,
      testId: "versionCompareData",
    },
    count: {
      displayText: countDesc,
      hidden: false,
      testId: countDesc.toLowerCase().replace(/\s+/g, "-"),
    },
    description: {
      displayText: description,
      hidden: false,
      noResize: true,
      sizeContentToFit: true,
      testId: description.toLowerCase().replace(/\s+/g, "-"),
    },
    versionCount: {
      displayText: (!!props.version ? `${countDesc} ${moment.utc(props.version.dateCreated).local().format("MMM DD, YYYY h:mm:ss A")}` : ""),
      hidden: false,
      testId: "versionData",
    },
  };

  if (!!props.compareVersion) {
    columnConfig.count.hidden = true;
  } else {
    columnConfig.change.hidden = true;
    columnConfig.changePerc.hidden = true;
    columnConfig.compareVersionCount.hidden = true;
    columnConfig.versionCount.hidden = true;
  }

  return columnConfig;
}

